import { Component, OnInit, Inject, Input, OnChanges, SimpleChanges } from '@angular/core';
import {
    InterestBasedProductCashFlow,
} from '@liquitics/transaction';

@Component({
    selector: 'app-cash-flow-table',
    templateUrl: './cash-flow-table.component.html',
    styleUrls: ['./cash-flow-table.component.scss']
})
export class CashFlowTableComponent implements OnInit {
    allColumns: any[];
    // @Input()
    // loanCashFlows: InterestBasedProductCashFlow[];
    tableData: InterestBasedProductCashFlow[];
    @Input()
    rowsPerPage = 20;
    loading = false;

    constructor() {
    }

    ngOnInit() {
        this.allColumns = [
            // tslint:disable:max-line-length
            { field: 'tradeId', header: 'ID', width: '5em', type: 'string', sortable: true },
            { field: 'product', header: 'Product', width: '5em', type: 'string', sortable: true },
            { field: 'currency', header: 'Ccy', width: '2em', type: 'string', sortable: true },
            { field: 'startDate', header: 'Start', width: '4em', type: 'date', sortable: true },
            { field: 'maturityDate', header: 'Maturity', width: '4em', type: 'date', sortable: true },
            { field: 'tradeDatetime', header: 'Trade DT', width: '5em', type: 'datetime', sortable: true },
            { field: 'enteredDate', header: 'Entered DT', width: '5em', type: 'datetime', sortable: true },
            { field: 'interestRate', header: 'Int Rate', width: '2em', type: 'number', sortable: true },
            { field: 'anchorDate', header: 'Anchor', width: '5em', type: 'date', sortable: true },
            { field: 'interestCalcFrequency', header: 'Int Freq', width: '5em', type: 'string', sortable: true },
            { field: 'interestRollingDay', header: 'Int Roll Day', width: '2em', type: 'string', sortable: true },
            { field: 'interestCalcDayCount', header: 'Int DC', width: '3em', type: 'string', sortable: true },
            { field: 'stubRule', header: 'Stub', width: '3em', type: 'string', sortable: true },
            { field: 'notional', header: 'Notional', width: '5em', type: 'number', sortable: true },
            { field: 'type', header: 'Type', width: '4em', type: 'string', sortable: true },
            { field: 'cfStartDate', header: 'CF Start', width: '4em', type: 'date', sortable: true },
            { field: 'cfEndDate', header: 'CF End', width: '4em', type: 'date', sortable: true },
            { field: 'cfPaymentDate', header: 'Payment', width: '4em', type: 'date', sortable: true },
            { field: 'yearFrac', header: 'Year Frac', width: '4em', type: 'number', sortable: true },
            { field: 'cfAmount', header: 'Amount', width: '5em', type: 'amount', sortable: true },

        ];
    }

    showCashFlows(loanCashFlows: InterestBasedProductCashFlow[]) {
        this.tableData = loanCashFlows
            .map((row: any, index) => {
                row.index = index;
                return row;
            });
        this.loading = false;
    }

    // ngOnChanges(changes: SimpleChanges): void {
    //     if (changes.loanCashFlows && changes.loanCashFlows.currentValue) {
    //         this.tableData = changes.loanCashFlows.currentValue
    //             .map((row, index) => {
    //                 row.index = index;
    //                 return row;
    //             });
    //     }
    //     this.loading = false;
    // }
}
